// extracted by mini-css-extract-plugin
export default {"cautionBox":"f7-z"};